import { Group, Paper, Stack, Text, Divider } from '@mantine/core';
import { EventType, EventInfo } from '../types';
import CalendarEventStatusIcon from './Calendar.event-status-icon';
import React from 'react';
import dayjs from 'dayjs';

export const EventTooltipContent: React.FC<{
  events: EventInfo[];
  type: EventType;
}> = ({ events, type }) => {
  const sortedEvents = events.toSorted(
    (a, b) => dayjs(a.startTime).valueOf() - dayjs(b.startTime).valueOf()
  );
  const tooltipContent = sortedEvents.map((event, index) => {
    return (
      <React.Fragment key={event.id}>
        <Group wrap="nowrap" align="center" w="100%" gap="xs">
          <CalendarEventStatusIcon status={event.status} />
          <Text truncate="end" fz="sm">
            <Text tt="capitalize" fw="bold" fz="sm" span>
              {type} Event
            </Text>{' '}
            {event.accountName && `at ${event.accountName}`}
          </Text>
        </Group>
        {index < sortedEvents.length - 1 && <Divider my={4} />}
      </React.Fragment>
    );
  });
  return (
    <Paper p="sm" c="var(--mantine-color-text)" shadow="md">
      <Stack gap={0}>{tooltipContent}</Stack>
    </Paper>
  );
};
